import { FunctionComponent } from 'react';
import { Flex, IconButton, Spinner } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { StandingRowMode } from '../../types';

type RowActionsProps = {
  mode: StandingRowMode;
  hasChanges?: boolean;
  onEdit?: () => void;
  onSave?: () => void;
  onCancel?: () => void;
  onDelete?: () => void;
  isDeleting?: boolean;
};

const PREFIX = 'pages.application_championship_stage_standings.row_actions';

export const RowActions: FunctionComponent<RowActionsProps> = ({
  mode,
  hasChanges = false,
  onEdit,
  onSave,
  onCancel,
  onDelete,
  isDeleting = false,
}) => {
  const { t } = useTranslation();

  if (mode === 'saving') {
    return (
      <Flex justify="center" align="center" minW="72px">
        <Spinner size="sm" color="brand.500" />
      </Flex>
    );
  }

  if (mode === 'edit') {
    return (
      <Flex gap={1} justify="center">
        <IconButton
          aria-label={t(`${PREFIX}.save`)}
          icon={<ChakraFeatherIcon name="check" boxSize="16px" />}
          size="sm"
          colorScheme="green"
          variant="ghost"
          onClick={onSave}
          isDisabled={!hasChanges}
        />
        <IconButton
          aria-label={t(`${PREFIX}.cancel`)}
          icon={<ChakraFeatherIcon name="x" boxSize="16px" />}
          size="sm"
          variant="ghost"
          color="gray.500"
          onClick={onCancel}
        />
      </Flex>
    );
  }

  return (
    <Flex gap={1} justify="center">
      <IconButton
        aria-label={t(`${PREFIX}.edit`)}
        icon={<ChakraFeatherIcon name="edit-2" boxSize="14px" />}
        size="sm"
        variant="ghost"
        color="gray.500"
        onClick={onEdit}
        isDisabled={isDeleting}
      />
      <IconButton
        aria-label={t(`${PREFIX}.delete`)}
        icon={<ChakraFeatherIcon name="trash-2" boxSize="14px" />}
        size="sm"
        variant="ghost"
        color="red.500"
        onClick={onDelete}
        isLoading={isDeleting}
      />
    </Flex>
  );
};
